import { Component } from '@angular/core';
import { Observable } from 'rxjs';

import { VersionUpdateService } from './core/version/version-update.service';
import { UserService } from './service/user.service';
import { WorkflowStatusToastHandler } from './service/workflow-status-toast.handler';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  isAuthenticated: Observable<boolean>;
  isDoneLoading: Observable<boolean>;
  canActivateProtectedRoutes: Observable<boolean>;

  constructor(
    private userService: UserService,
    private workflowStatusToasts: WorkflowStatusToastHandler,
    private versionUpdates: VersionUpdateService,
    //private authService: AuthService,
    ) {


    /*
    this.isAuthenticated = this.authService.isAuthenticated$;
    this.isDoneLoading = this.authService.isDoneLoading$;
    this.canActivateProtectedRoutes = this.authService.canActivateProtectedRoutes$;
    */

    /*
    this.authService.runInitialLoginSequence();

    this.isAuthenticated.subscribe((authState) => {
      if (authState === true) {
        console.log('AppComponent', 'User authenticated');

        this.usersService.getCurrentUser().subscribe((user) => {
          this.userActions.set(user);
        });
      }
    });
    */

    this.userService.loadCurrentUser();
    this.workflowStatusToasts.start();
    // Pick up new deploys at the next navigation (console-automatic-upgrade).
    // A no-op in unstamped builds, so `ng serve` and Karma start no timers.
    this.versionUpdates.start();
  }

  /*
  logoutExternally() {
    window.open(this.authService.logoutUrl);
  }
  */
}
